export const heroBannerStyles = {
  root: 'relative w-full overflow-hidden bg-brand-950 text-brand-100',
  media: 'absolute inset-0',
  image: 'h-full w-full object-cover opacity-40',
  toneFallback: 'absolute inset-0 bg-brand-900',
  overlay: 'absolute inset-0 bg-brand-950/70',
  content:
    'relative mx-auto flex max-w-7xl flex-col gap-4 px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20',
  eyebrow: 'font-sans text-sm font-medium uppercase tracking-wide text-brand-200',
  title: 'font-heading text-heading-2xl text-brand-100 sm:text-heading-3xl lg:text-heading-3xl max-w-3xl',
  description: 'max-w-xl font-sans text-md text-brand-200 sm:text-lg',
  actions: 'mt-2 flex flex-wrap items-center gap-3',
} as const;
